import AddUserRequestListController from './add.user.request.list.controller';
import AddUserRequestListTemplate from './add.user.request.list.tpl.html';

export default {
	controller: AddUserRequestListController,
	template: AddUserRequestListTemplate
};
